import { set, toggle, wait } from 'cerebral/operators'
import { state } from 'cerebral/tags'

export default [
  toggle(state`node.tree.open`),
  set(state`node.tree.transition`, true),
  wait(450),
  set(state`node.tree.transition`, false)
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/toggleMenuOpen.js